import React, { useMemo } from "react";
import { useState } from "react";
import { Link, useSearchParams  } from "react-router-dom";
import "../../assets/style/admin/style.css";
import "../../assets/style/admin/all.min.css";
import Table from "../../components/admin/Table";
import { useEffect } from "react";
import {getList} from "../../slices/ProductsSlice";
import { useForm, Controller } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import defaultConfig from "../../config/Config";
import { CamelToSentanceCase } from "../../Utils/utils/CommanFnc";
import SelectBox from "../../components/admin/SelectBox";
import { getBrands, getCatList } from "../../slices/InitialDataSlice";
export function ProductsList() {
  const [products, setProductsData] = useState([]);
  const [columsData, setColumsData] = useState([]);
  const [cateList, setCateList] = useState([]);
  const [brandList, setBrandList] = useState([]);
  const data = useSelector((state) => state.products);
  const brands = useSelector((state) => state.initialData.brands);
  const categories = useSelector((state) => state.initialData.categories);
  const [searchParams, setSearchParams] = useSearchParams()
  const queryString = Object.fromEntries([...searchParams.entries()])
  const {
    register,
    control,
    setValue,
    handleSubmit,
  } = useForm({
    mode: "onBlur",
  });

  const [defaultParams, setDefaultParams] = useState({
    pageLength:queryString.pageLength?queryString.pageLength:defaultConfig.defaultLimit,
    page:queryString.page?queryString.page:1,
  })
  // const [serachString, setSearchString] = useState({
  //   searchString:queryString.searchString?queryString.searchString:''
  // })

  const dispatch = useDispatch()  
  const columns = useMemo( () => {
    return [
      {
        
        name:"Name",
        width: '20%',
        selector: (row) => row.name,
        wrap: true,
        sortable: true,
        center: true,
      },
      {
        name: "Quantity",
        width: '9%',
        selector: (row) => row.quantity,
        wrap: true,
        sortable: true,
        center: true,
      },
      {
        name: "Default Price",
        width: '12%',
        selector: (row) => row.price,
        wrap: true,
        sortable: true,
        center: true,
      },
      {
        name: "Unit",
        selector: (row) => row.unit,
        sortable: true,
        center: true,
      },
      {
        name: "Brand",
        selector: (row) => row.brands.name,
        sortable: true,
        center: true,
      },
      {
        name: "Category",
        selector: (row) => row.categories.name,
        sortable: true,
        center: true,
      },
      {
        name:"Status",
        selector: (row) => row.status,
        sortable:false,
        center:true,
        cell: (row) => (
          <>
            <i className={`far fa-dot-circle fa-w-16 ${row.status === 'active'?'text-success':'text-muted'}`} aria-hidden="true"></i>
            &nbsp;
            {CamelToSentanceCase(row.status) || 'Inactive'}
          </>
        )
      },
      {
        name: "Action",
        button: false,
        selector: "action",
        center: true,
        cell: (row) => (
          // <button onClick={ ()=>openEditPage(row) } className="btn">
          //   {" "}
          //   <i className="fa fa-edit"></i>{" "}
          // </button>
          <Link 
            to={{
              pathname: `/products/edit/${row._id}`,
              search: "",
              hash: "",
            }} replace 
            state={defaultParams}
            className="sidebar-link" data-toggle="tab">
            {" "}
            <i className="fa fa-edit"></i>{" "}
          </Link>
        ),
        ignoreRowClick: true,
        allowOverflow: true,
      },
    ]
  },[defaultParams])
  
  useEffect(()=>{
    if(Object.keys(queryString).length === 0){
      dispatch(getList(defaultParams))
    }else{
      setDefaultParams({...defaultParams, ...queryString})
      if(queryString.brandId)
        onBrandChange(queryString.brandId)
      setSearchValues(queryString)
    }
    dispatch(getBrands())
  //eslint-disable-next-line react-hooks/exhaustive-deps
  },[dispatch]);

  useEffect( () =>{
    setColumsData(columns)
  },[columns, defaultParams])

  useEffect( ()=>{
    setProductsData(data)
  },[data])

  useEffect(()=>{
    if(typeof categories === "object"){
      let list = []
      list = categories?.map( ({_id, name}) => { return {label: name, value: _id} } )  
      setCateList(list)
    }
    
    if(brands) {
      let list = brands?.map( ({_id, name}) => { return {label: name, value: _id }} );
      setBrandList( list )
    }
    
  },[brands, categories])

  const setSearchValues = (queryString) => {
    for( let key in queryString ){
      if( key !== "statePrice"){
        setValue(key, queryString[key])
      }
    }
  }

  async function onSearch(data){
    if(!data.searchString){
      data.searchString = ""
    }
    if(!data.brandId){
      data.brandId = ""
    }
    if(!data.category){
      data.categoryId = ""
    }

    const queryPrm = {pageLength: defaultConfig.defaultLimit, page:1, ...data}
    let params = Object.assign(defaultParams, {...queryPrm})
    setDefaultParams(params)
    setSearchParams(params)
    dispatch(getList({data: {...params}}))
  };

  const setPaginationData = (paginationData) =>{
    const params = {...defaultParams, page: paginationData.page, pageLength: paginationData.pageLength}
    setDefaultParams(params)
    setSearchParams(params)
  }

  const resetSearch = () =>{
    const queryPrm = {pageLength: defaultConfig.defaultLimit, page:1}
    setDefaultParams(queryPrm)
    setSearchParams(queryPrm)  
    dispatch(getList(queryPrm))
  }

  function onBrandChange(value, callBack) {
    dispatch( getCatList({type:"product", brandId: value}) )
    if(typeof callBack === "function")
      callBack(value);
  }


  return (
    <div className="revenue-wrapper">
      <div className="row">
        <div className="col-lg-12">
          <div className="card table-card">
            <div className="d-sm-flex justify-content-between align-items-center pl-4 pr-4">
              <h4 className="card-title mB25 mb-sm-0"><i className="fas fa-tags"></i> Products</h4>
            </div>
            <div className="row m-3">
                <div className="col-sm-8">
                  <form onSubmit={handleSubmit(onSearch)}>
                      <div className="row">   
                        <div className="col-sm-3 p-0 ml-1">
                          <div className="form-group mb-3">
                             <input
                             {...register("searchString")}
                             type="text"
                             defaultValue=""
                             placeholder="Search by title"
                             className="input-txt form-control"
                             />
                          </div>
                        </div>
                        &nbsp;
                        <div className="col-sm-3 p-0">
                          <div className="form-group mb-3">
                             <Controller
                               control={control}
                               name="brandId"
                               //value={defaultConfig.status[0]["value"]}
                               //defaultValue={defaultConfig.status[0]["value"]}
                               render={({ field: { value, onChange } }) => (
                                 <SelectBox
                                   options={brandList}
                                   isClearable={true}
                                   onChange={(opt) =>  onBrandChange(opt?.value, onChange)}
                                   value={brandList?.find(
                                     (option) => option.value === value
                                   ) || ''}
                                 />
                               )}
                             />
                          </div>
                        </div>
                        &nbsp; 
                        <div className="col-sm-3 p-0">
                          <div className="form-group mb-3">
                             <Controller
                               control={control}
                               name="categoryId"
                               //value={defaultConfig.status[0]["value"]}
                               //defaultValue={defaultConfig.status[0]["value"]}
                               render={({ field: { value, onChange } }) => (
                                 <SelectBox
                                   options={cateList}
                                   isClearable={true}
                                   onChange={(opt) => onChange(opt?.value)}
                                   value={cateList.find(
                                     (option) => option.value === value
                                   ) || ''}
                                 />
                               )}
                             />
                          </div>
                        </div>
                        &nbsp;
                        <div className="col-sm-2 col-1 p-0 ml-1">
                           <button type="submit" className="btn btn-primary btn-lg">
                             <i className="fa fa-search"></i>
                           </button>
                           &nbsp;
                           <button type="reset" onClick={resetSearch} title="Reset" className="btn btn-primary btn-lg">
                             <i className="fas fa-undo"></i>
                           </button>
                        </div>
                      </div>
                  </form> 
                </div>
                <div className="col-sm-4 text-right">
                  <Link
                    to={"/products/add"}
                    className="button blue-button btn-success"
                    data-toggle="tab"
                  >
                    <i className="fas fa-tag"></i>
                    {" "}
                    Add Products{" "}
                  </Link>
                </div>
              </div>
            <Table 
              totalCount={products?.totalCount}
              data={products.list} 
              columns={columsData} 
              dataLoadFnc={getList} 
              extraConfig = {defaultParams}  
              loading={products.loading}
              callBack={setPaginationData}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
